// This function allow to reference async chunks
__webpack_require__.u = function(chunkId) {
	// return url for filenames based on template
	return "" + ({"678":"component---src-pages-index-js","883":"component---src-pages-404-js"}[chunkId] || chunkId) + "-" + {"589":"7a1ad1286c4b071b5087","678":"39147bf367e0b71eb814","883":"9d26c7e9ac5a2e6e83fb"}[chunkId] + ".js";
};